import { Pipe, PipeTransform } from '@angular/core';
import { LogModelEnum } from '../enums/log-model.enum';
import { ScenarioItemSubType } from '../enums/scenario-Item-sub-type.enum';

@Pipe({
  name: 'filterLog',
})
export class FilterLogPipe implements PipeTransform {
  transform(
    value: Array<any>,
    params: { param: string; key?: number | string },
  ): any[] {
    return value.filter((el) => {
      if (el.model === LogModelEnum.ITEM) {
        if (el.subType === ScenarioItemSubType.MULTI_CHOICE) {
          for (const elKey in el.res) {
            return el.res[elKey].isLoggist === params.key ? true : false;
          }
        } else {
          return (el.results = el.results.filter(
            (res) => res.user?.isLoggist === params.key,
          ));
        }
      } else {
        if (el.user.isLoggist === params.key) {
          return el;
        }
      }
    });
  }
}
